import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-variable-color-large.tsx
/**
* icon.24.variable.color.large
*
* Keywords: palette, art, paint, creative, design, color-picker, artist
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTUuNjM2IDUuNjM2YTkgOSAwIDAgMSAxNS4yMjkgNy45MThDMjAuNTg1IDE1LjE1OSAxOS4xIDE2IDE3LjczMSAxNkgxNGExIDEgMCAwIDAtMSAxdi41YzAgLjk2LS4zOTYgMS44NjctMS4wNjYgMi40NzUtLjY4Ny42MjMtMS42NjkuOTI0LTIuNy41OTFhOSA5IDAgMCAxLTMuNTk4LTE0LjkzbTEyLjAyLjcwN0E4IDggMCAxIDAgOS41NCAxOS42MTRjMS4zMTQuNDI0IDIuNDYtLjczMyAyLjQ2LTIuMTE0VjE3YTIgMiAwIDAgMSAyLTJoMy43MzFjLjk1NiAwIDEuODU1LS41NCAyLjEwOC0xLjQzNWwuMDQtLjE4M2E3Ljk5IDcuOTkgMCAwIDAtMi4yMjMtNy4wNE03LjUgMTJhMSAxIDAgMSAxIDAgMiAxIDEgMCAwIDEgMC0ybTguNS0yYTEgMSAwIDEgMSAuMDAxIDIgMSAxIDAgMCAxIDAtMk04LjUgNy41YTEgMSAwIDEgMS0uMDAxIDIgMSAxIDAgMCAxIDAtMm00LjUtMWExLjAwMSAxLjAwMSAwIDAgMSAwIDIgMS4wMDEgMS4wMDEgMCAwIDEgMC0yIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=4260-8447
*/
const Icon24VariableColorLarge = memo(function Icon24VariableColorLarge(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M5.636 5.636a9 9 0 0 1 15.229 7.918C20.585 15.159 19.1 16 17.731 16H14a1 1 0 0 0-1 1v.5c0 .96-.396 1.867-1.066 2.475-.687.623-1.669.924-2.7.591a9 9 0 0 1-3.598-14.93m12.02.707A8 8 0 1 0 9.54 19.614c1.314.424 2.46-.733 2.46-2.114V17a2 2 0 0 1 2-2h3.731c.956 0 1.855-.54 2.108-1.435l.04-.183a7.99 7.99 0 0 0-2.223-7.04M7.5 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2m8.5-2a1 1 0 1 1 .001 2 1 1 0 0 1 0-2M8.5 7.5a1 1 0 1 1-.001 2 1 1 0 0 1 0-2m4.5-1a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M5.636 5.636a9 9 0 0 1 15.23 7.918C20.584 15.159 19.1 16 17.73 16H14a1 1 0 0 0-1 1v.5c0 .96-.396 1.867-1.065 2.475-.688.623-1.67.924-2.702.591a9 9 0 0 1-3.597-2.203 9 9 0 0 1 0-12.727m12.02.707A8 8 0 1 0 9.54 19.614c1.314.424 2.46-.733 2.46-2.114V17a2 2 0 0 1 2-2h3.731c.956 0 1.855-.54 2.108-1.435l.04-.183a7.99 7.99 0 0 0-2.223-7.04M8 13a1 1 0 1 1-.001 2.001A1 1 0 0 1 8 13m7.999-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2M8 8a1 1 0 1 1-.001 2.001A1 1 0 0 1 8 8m5-2a1 1 0 1 1-.002 2.002A1 1 0 0 1 13 6"
		})
	});
});
//#endregion
export { Icon24VariableColorLarge };

//# sourceMappingURL=icon-24-variable-color-large.js.map